import React, { useMemo, useState } from 'react';
import { u as useInterval } from './useInterval-04c7ed1d.js';
import { s as styled } from './styled-112a8bd0.js';

const Wrapper = styled.div `
  display: flex;
`;
const sizeMaps = {
    sm: '24px',
    md: '45px',
    lg: '55px',
};
const fontSizeMaps = {
    sm: '12px',
    md: '20px',
    lg: '24px',
};
const Segment = styled.div(({ size }) => `
  width: ${sizeMaps[size]};
  height: ${sizeMaps[size]};
  border-radius: 4px;
  background-image: linear-gradient(to bottom, #4a4a4a, #232222);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${fontSizeMaps[size]};
  font-weight: 700;
  overflow: hidden;
`);
const NumberFrame = styled.div `
  height: 45px;
  display: flex;
  align-items: center;
`;
const spacerSizeMap = {
    sm: '0.2rem',
    md: '0.5rem',
    lg: '0.8rem',
};
const Spacer = styled.div(({ size }) => `
  width: ${spacerSizeMap[size]};
`);
const extractParts = (number) => {
    const out = number.toString().padStart(2, '0');
    return [Number(out[0]), Number(out[1])];
};
const DefaultCountdown = ({ duration, size }) => {
    const [sec1, sec2] = useMemo(() => extractParts(duration.seconds), [duration.seconds]);
    const [min1, min2] = useMemo(() => extractParts(duration.minutes), [duration.minutes]);
    const [hour1, hour2] = useMemo(() => extractParts(duration.hours), [duration.hours]);
    return (React.createElement(Wrapper, null,
        React.createElement(Segment, { size: size },
            React.createElement(NumberFrame, null, hour1),
            React.createElement(NumberFrame, null, hour2)),
        React.createElement(Spacer, { size: size }),
        React.createElement(Segment, { size: size },
            React.createElement(NumberFrame, null, min1),
            React.createElement(NumberFrame, null, min2)),
        React.createElement(Spacer, { size: size }),
        React.createElement(Segment, { size: size },
            React.createElement(NumberFrame, null, sec1),
            React.createElement(NumberFrame, null, sec2))));
};

const calculateTimeDelta = (date) => {
    let startTimestamp;
    if (typeof date === 'string') {
        startTimestamp = new Date(date).getTime();
    }
    else if (date instanceof Date) {
        startTimestamp = date.getTime();
    }
    else {
        startTimestamp = date;
    }
    const durationInMs = Math.round(parseFloat((Math.max(0, startTimestamp - Date.now()) / 1000).toFixed(0)) *
        1000);
    const durationInSecond = durationInMs / 1000;
    return {
        durationInMs,
        days: Math.floor(durationInSecond / (3600 * 24)),
        hours: Math.floor((durationInSecond / 3600) % 24),
        minutes: Math.floor((durationInSecond / 60) % 60),
        seconds: Math.floor(durationInSecond % 60),
    };
};
const DefaultRenderer = (duration, size = 'md') => React.createElement(DefaultCountdown, { duration: duration, size: size });
const Countdown = ({ date, renderer = DefaultRenderer, className, size = 'md', }) => {
    const [duration, setDuration] = useState(calculateTimeDelta(date));
    useInterval(() => {
        setDuration(calculateTimeDelta(date));
    }, 1000, duration.durationInMs === 0);
    return (React.createElement("div", { className: className }, renderer && renderer(duration, size)));
};

export { Countdown as C, calculateTimeDelta as c };
